import * as actionTypes from './actionTypes'


export const getVideoPlayData = () => ({
    type: actionTypes.GET_VIDEO_PLAY_DATA
})

export const setVideoPlayData = data => ({
    type: actionTypes.SET_VIDEO_PLAY_DATA,
    data
})




